export enum TeamTypeSettingsPrivacyLevel {
	Private,
	Public,
	// "Open" means that the requester can decide the privacy level.
	Open
}